export default "__VITE_ASSET__55379c56__"